export default __webpack_public_path__ + "static/media/Currencies.f7ba2ec1.svg";